import React, { FC } from "react"
import { Modal } from "antd"
import { useStore } from "stores/utils/use-store"

export const RevokeBattlePass: FC<{
  visible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}> = ({ visible, onClose, onSuccess }) => {
  const { dataStore: { accountDetailsStore } } = useStore()

  return (
    <Modal
      visible={visible}
      title="Revoke Buff Pass?"
      onCancel={() => onClose()}
      onOk={async() => {
        accountDetailsStore.funcAfterSuccess = async() => {
          onClose()
          accountDetailsStore.resetFuncAfterSuccess()
          if (onSuccess) {
            onSuccess()
          }
        }
        await accountDetailsStore.revokeBattlePass()
      }}
      okText="Revoke"
      cancelText="Cancel"
      okType="danger"
      confirmLoading={accountDetailsStore.isLoading}
    >
      Do you really want to revoke Buff Pass for this user?
    </Modal>
  )
}

